module.exports = __webpack_public_path__ + "static/media/icon_search.75d7c1c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_search.svg
// module id = 231
// module chunks = 0